var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { extractAccessToken, getBaseURL } from '@la/utilities';
import { getAccountInfo } from './getAccountInfo';
const baseUrl = getBaseURL();
const searchMembers = ({ siteId, search, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { orgAccount: { id: orgId }, } = yield getAccountInfo({ siteId });
    const endpoint = `${baseUrl}/v3/member/orgs/${orgId}/members?query=${search}&pageSize=20&siteIds=${siteId}`;
    const token = extractAccessToken();
    try {
        const response = yield axios.get(endpoint, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.members;
    }
    catch (e) {
        if (e.response.status === 404) {
            return null;
        }
        throw e;
    }
});
export { searchMembers };
